import Metro from 'pages/Metro';
import Login from 'pages/Login';
import LostPassword from 'pages/LostPassword';
import Register from 'pages/Register';
import Error404 from 'pages/Error404';
import Maintenance from 'pages/Maintenance';
import Home from 'pages/Home';
import MyAccount from 'pages/MyAccount';
import MyCoupons from 'pages/MyCoupons';
import AccountCoupons from 'pages/AccountCoupons';
import AccountCouponsChange from 'pages/AccountCouponsChange';
import TermsConditions from 'pages/TermsConditions';
import Privacy from 'pages/Privacy';
import Categories from 'pages/Categories';
import TermsConditionsPublic from 'pages/TermsConditionsPublic';
import PrivacyPublic from 'pages/PrivacyPublic';
import DataProtectionPublic from 'pages/DataProtectionPublic';
import DataProtection from 'pages/DataProtecction';
import PoliCookiesPublic from 'pages/PoliCookiesPublic';
import PoliCookies from 'pages/PoliCookies';
import FrequentQuestions from 'pages/FrequentQuestions';
import PageFacebook from 'pages/PageFacebook';
import TermsConditionsQrPublic from 'pages/TermsConditionsQrPublic';
import PrivacyQrPublic from 'pages/PrivacyQrPublic';
import PoliCookiesQRPublic from 'pages/PoliCookiesQrPublic';
import DataProtectionQrPublic from 'pages/DataProtectionQrPublic';
import MyCouponsQrPublic from 'pages/MyCouponQrPublic';


const publicRoutes = [
    {
        path: "/",
        component: Metro
    },
    {
        path: "/login",
        component: Login
    },
    {
        path: "/lost-password",
        component: LostPassword
    },
    {
        path: "/register",
        component: Register
    },
    {
        path: "/terms_condition-public",
        component: TermsConditionsPublic
    },
    {
        path: "/privacy-public",
        component: PrivacyPublic
    },
    {
        path: "/cookies-public",
        component: PoliCookiesPublic
    },
    {
        path: "/data_protection-public",
        component: DataProtectionPublic
    },
    {
        path: "/my-coupons/qr/:id",
        component: MyCouponsQrPublic
    },
    {
        path: "/terms_condition-public/qr/:id",
        component: TermsConditionsQrPublic
    },
    {
        path: "/privacy-public/qr/:id",
        component: PrivacyQrPublic
    },
    {
        path: "/cookies-public/qr/:id",
        component: PoliCookiesQRPublic
    },
    {
        path: "/data_protection-public/qr/:id",
        component: DataProtectionQrPublic
    },
    {
        path: "/frequent-questions",
        component: FrequentQuestions

    },
    {
        path: "/facebook",
        component: PageFacebook

    }
    
];

const privateRoutes = [
    {
        path: "/metro",
        component: Metro
    },
    {
        path: "/home",
        component: Home
    },
    {
        path: "/account/my-account",
        component: MyAccount
    },
    {
        path: "/account/my-coupons",
        component: MyCoupons
    },
    {
        path: "/account/terms",
        component: TermsConditions
    },
    {
        path: "/account/privacy",
        component: Privacy
    },
    {
        path: "/account/data-protection",
        component: DataProtection
    },
    {
        path: "/account/cookies",
        component: PoliCookies
    },
    {
        path: "/account-coupons",
        component: AccountCoupons
    },
    {
        path: "/account-coupons-change/:id",
        component: AccountCouponsChange
    },
    {
        path: "/categories/:handle", 
        component: Categories
    },    {
        path: "/account-frequent-questions",
        component: FrequentQuestions

    }
];

export {
    publicRoutes,
    privateRoutes,
    Error404,
    Maintenance
};
